import React from 'react';
import {ApiContext} from "./api-config";

const withApi = (Component)=>(props)=>
    <ApiContext.Consumer>{(api)=><Component {...props} api={api} />}</ApiContext.Consumer>

export default withApi;

